import { render, staticRenderFns } from "./AuditHistory.vue?vue&type=template&id=0dc35388&scoped=true"
import script from "./AuditHistory.vue?vue&type=script&lang=js"
export * from "./AuditHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc35388",
  null
  
)

export default component.exports